module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARMAAABFAQAAAABBcj9LAAAABGdBTUEAALGPC/xhBQAAAAJiS0dEAAHdihOkAAAACXBIWXMAAAEsAAABLABziOlSAAAAB3RJTUUH4ggeDxMkQV6ZOgAAACNJREFUSMdj+E8QPGAYVTOqZlTNqJpRNaNqRtWMqhlVM6BqAHlaXb47GuNEAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE4LTA4LTMwVDE1OjE5OjM2LTA0OjAwkN7fMgAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxOC0wOC0zMFQxNToxOTozNi0wNDowMOGDZ44AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/publimetro-logo.png
// module id = VQ6P
// module chunks = 1